import { ButtonHTMLAttributes, FC } from 'react';

const PrimaryButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ className = '', type = 'button', ...props }) => (
  <button
    type={type}
    className={`flex w-full items-center justify-center gap-1.5 rounded-lg bg-primary-button-default px-4 py-2.5 font-roboto text-md font-semibold text-ftux-label outline outline-[3px] outline-ftux-stroke transition-colors hover:bg-primary-button-hover disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
    {...props}
  />
);

export default PrimaryButton;
